var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"agreement-container"},[_vm._v(" Users are advised to read the "),_c('a',{attrs:{"href":"https://www.bohemia.net/privacy-policy","rel":"noopener noreferrer","target":"_blank"}},[_vm._v("User Agreement & Privacy Policy.")])])])
}]

export { render, staticRenderFns }